import { render, staticRenderFns } from "./GroupingPic.vue?vue&type=template&id=f9034ea6&scoped=true"
import script from "./GroupingPic.vue?vue&type=script&lang=js"
export * from "./GroupingPic.vue?vue&type=script&lang=js"
import style0 from "./GroupingPic.vue?vue&type=style&index=0&id=f9034ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9034ea6",
  null
  
)

export default component.exports